import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Star, Plus, ShoppingCart } from 'lucide-react';
import { products } from '../data/products';
import { useCart } from '../context/CartContext';
export function Shop() {
  const {
    addItem
  } = useCart();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="pt-32 pb-24 bg-brand-cream min-h-screen" data-id="element-408">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-409">
        <div className="text-center mb-16" data-id="element-410">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-brand-dark mb-6" data-id="element-411">
            Shop
          </h1>
          <p className="text-brand-gray max-w-2xl mx-auto" data-id="element-412">
            Toont alle {products.length} resultaten
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-413">
          {products.map(product => <div key={product.id} className="group relative bg-white rounded-2xl p-4 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col" data-id="element-414">
              {product.tag && <span className="absolute top-6 left-6 z-10 bg-brand-dark text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-415">
                  {product.tag}
                </span>}

              <Link to={`/product/${product.slug}`} className="block relative aspect-square overflow-hidden rounded-xl mb-6 bg-gray-100" data-id="element-416">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" loading="lazy" data-id="element-417" />

                {/* Quick Add Overlay */}
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-6 pointer-events-none" data-id="element-418">
                  <button onClick={e => {
                e.preventDefault();
                addItem(product);
              }} className="bg-white text-brand-dark px-6 py-3 rounded-full font-medium flex items-center gap-2 hover:bg-brand-red hover:text-white transition-colors transform translate-y-4 group-hover:translate-y-0 duration-300 pointer-events-auto" data-id="element-419">
                    <ShoppingCart size={18} data-id="element-420" />
                    Snel Toevoegen
                  </button>
                </div>
              </Link>

              <div className="flex-grow flex flex-col" data-id="element-421">
                <div className="flex items-center gap-1 mb-2" data-id="element-422">
                  <Star size={14} className="fill-brand-yellow text-brand-yellow" data-id="element-423" />
                  <span className="text-sm font-medium" data-id="element-424">{product.rating}</span>
                  <span className="text-sm text-brand-gray" data-id="element-425">
                    ({product.reviews})
                  </span>
                </div>

                <Link to={`/product/${product.slug}`} className="hover:text-brand-red transition-colors" data-id="element-426">
                  <h3 className="font-serif font-semibold text-lg text-brand-dark mb-2 leading-tight" data-id="element-427">
                    {product.name}
                  </h3>
                </Link>

                <div className="mt-auto flex items-center justify-between pt-4" data-id="element-428">
                  <span className="text-xl font-bold text-brand-dark" data-id="element-429">
                    €{product.price.toFixed(2)}
                  </span>
                  <button onClick={() => addItem(product)} aria-label={`${product.name} toevoegen aan winkelwagen`} className="w-10 h-10 rounded-full bg-brand-cream flex items-center justify-center text-brand-dark hover:bg-brand-red hover:text-white hover:scale-110 transition-all" data-id="element-430">
                    <Plus size={20} data-id="element-431" />
                  </button>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </main>;
}